// extracted by mini-css-extract-plugin
export default {"gradientBorder":"shared_gradientBorder__Jeoet","shadowBorder":"shared_shadowBorder__p2uha"};